import {RemoteGetOpinionsList} from 'data/usecases/private/my-hospitalization/remote-get-opinions-list';
import {GetOpinionsList} from 'domain/usecases/private/my-hospitalization/get-opinions-list';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyHospitalizationEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetOpinionsList = (): GetOpinionsList =>
	new RemoteGetOpinionsList(
		makeBFFApiUrl(MyHospitalizationEndpoints.opinionsList),
		makeAuthorizeHttpClientDecorator(),
	);
